import { Component, OnInit, HostListener, OnChanges, AfterViewInit, AfterViewChecked, AfterContentInit } from '@angular/core';
import { AuthenticationService } from '../authentication.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
// import { GoogleLoginProvider, FacebookLoginProvider } from 'angular-6-social-login';
declare var $: any;
import { MainService } from '../portal/service/main.service';
// import { MainService as MainServiceADMIN } from '../admin/service/main.service';
import { MainService as MainServiceADMIN } from '../admin/service/main.service';
import { HttpClient } from "@angular/common/http";
import { session } from '../../environments/environment.session'
import { SpinnerService } from '../shared/spinner.service'
import { en } from '../../environments/environment.tok'
import { Utf8EncodingService } from '../md/service/utf8-encoding.service';
enum CheckBoxType { APPLY_FOR_JOB, MODIFY_A_JOB, NONE };
//  import {session} from '../../../environments/environment.session'

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
export class SigninComponent implements OnInit, AfterContentInit {





  ngAfterViewInit() {
    // Logic to handle slide controls and initial state
    const loginText = document.querySelector(".title-text .otp-login") as HTMLElement;
    const loginForm = document.querySelector("form.otp-login") as HTMLElement;
    const loginBtn = document.querySelector("label.otp-login") as HTMLLabelElement;
    const signupBtn = document.querySelector("label.gp-login") as HTMLLabelElement;
    const signupLink = document.querySelector("form.gp-login .gp-login-link a") as HTMLAnchorElement;
    // Default styles
    loginForm.style.marginLeft = "0%";
    loginText.style.marginLeft = "0%";

    // Event handlers
    if (signupBtn) {
      signupBtn.onclick = () => {
        loginForm.style.marginLeft = "-50%";
        loginText.style.marginLeft = "-50%";
      };
    }

    if (loginBtn) {
      loginBtn.onclick = () => {
        loginForm.style.marginLeft = "0%";
        loginText.style.marginLeft = "0%";
      };
    }

    if (signupLink) {
      signupLink.onclick = (event: any) => {
        signupBtn.click();
        event.preventDefault();
      };
    }
  }



  submitLoginForm() {
    // Handle login form submission logic here
    console.log('Login form submitted');
  }

  submitSignupForm() {
    // Handle signup form submission logic here
    console.log('Signup form submitted');
  }

  erpUser: any;
  obj = { email: '', password: '', confirmPassword: '' }
  constructor(private tspinner: SpinnerService, private http: HttpClient,
    public mainServiceADMIN: MainServiceADMIN, private mainService: MainService,
    public utf8EncodingService: Utf8EncodingService,
    private router: Router, private snackBar: MatSnackBar, public auth: AuthenticationService) {
    sessionStorage.clear()
    this.erpUser = undefined
  }




  //login info add karne k liye Code
  lat: any;
  long: any;
  ipAddress: any;
  ipAddress2: any;
  browser: any;
  AllRoleZone = []
  data_auth_id: any;
  lng: any;
  zoom: any;
  login_obj: any = {
    user_id: null, login_time: null, login_ip: null, login_browser: null,
    latitude: null, longitude: null, active_from_time: null, logout_time: null,
    login_type: 'ONLOAD', status: 'NA', login_id: null, password: null, message: 'Just First view On Website...'
  }

  getIPAddress() {
    // this.http.get("https://api.ipify.org/?format=json").subscribe((res: any) => {
    //   this.ipAddress = res.ip;
    //   this.login_obj['login_ip'] = this.ipAddress;
    // });
  }
  geoLocation() {
    var pos;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async position => {
        let lat = position.coords.latitude;
        let lng = position.coords.longitude;
        this.zoom = 16;
        this.login_obj['latitude'] = lat;
        this.login_obj['longitude'] = lng;
      });
    }
    else {
      alert('Browser Does`t Supported')
    }
  }


  public getBrowserName() {
    const agent = window.navigator.userAgent.toLowerCase()
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }

  async ngAfterContentInit() {

    setTimeout(async () => {
      await this.geoLocation();
    }, 500);
    setTimeout(async () => {
      await this.getIPAddress();
    }, 500)

    //browser set

    this.browser = await this.getBrowserName();
    this.login_obj['login_browser'] = this.browser;

    //active time set
    var current = new Date();
    var date = current.toLocaleString();
    this.login_obj['active_from_time'] = date;
    setTimeout(async () => {
      await this.insertLoginInfo(this.login_obj);
    }, 3000)
  }


  async insertLoginInfo(obj: any) {
    // var resp = await this.auth.createloginInfo(obj);
  }



  //login info add karne k liye Code

  mobile_otp: any;
  otp_to_Match = 0;
  allowLogin: boolean = false;
  phone_no: any;
  your_password_flag = false;
  your_password: any;
  language_cd: any;


  async ngOnInit() {
    this.tspinner.show('', '')
    try {
      this.erpUser = this.utf8EncodingService.decodeFromUtf8((session.erpUser));
    } catch (err) {

    }
    // if(this.erpUser || sessionStorage.getItem('1001')){
    //   sessionStorage.removeItem("1001");
    //   sessionStorage.removeItem("1000");sessionStorage.removeItem("1005");
    //   this.router.navigate(['/index']);
    //   return
    // }
    // sessionStorage.removeItem('erpUser');
    // sessionStorage.removeItem('token');

    this.language_cd = this.auth.language_cd;
    this.login_with_password = this.auth.login_with_password
    this.tspinner.hide()
  }

  otp_flag: boolean = false;
  erpUserData = {};

  SubmitForgetPassword() {
  }

  close() {
  }

  error_msg1: any;
  error_flag1: any;
  otp_no: any;
  otp_mobile_no: any;
  AllAccountData: any = [];
  mobile_number: any;

  resendOTPbutton: boolean = false;
  sendOTPbutonHide: boolean = false;
  resendOTPMessage: String = ""
  time_in_second: any = 30 //in second


  async resendOTP() {
    await this.startTimer(this.time_in_second)
    this.resendOTPbutton = true;
    setTimeout(() => {
      this.resendOTPbutton = false;
    }, 1000 * this.time_in_second);
  }

  async startTimer(duration: any) {
    let time: String;
    const timeInterval = setInterval(() => {
      time = this.transform(--duration)
      this.resendOTPMessage = `Resend OTP in  ${time} second `;
      if (time === '0:0') {
        this.resendOTPMessage = ""
        clearInterval(timeInterval);
      }
    }, 1000);
    this.sendOTPbutonHide = true;
  }

  transform(value: number): string {
    const minutes: number = Math.floor(value / 60);
    return minutes + ':' + (value - minutes * 60);
  }

  async sendOtp() {
    var obj: any = new Object();
    obj['ident_to_verify'] = this.mobile_number;
    obj['ident_verify_method'] = 'OTP';
    var resp = await this.auth.loginERP(obj);
    if (resp['error'] == false) {
      if (resp['data'].length == 0) {
        Swal.fire("opps", this.auth.allLableShowObj[this.auth.language_cd + 'LOGIN17'], 'error');
        this.sendOTPbutonHide = true
        this.error_flag1 = true;
        this.otp_flag = true;
        return;
      } else {
        // this.otp_flag = false;
        this.error_msg1 = "";
        this.sendOTPbutonHide = false
        this.otp_flag = true;
        this.error_flag1 = false;
      };

    } else {
      Swal.fire("opps", this.auth.allLableShowObj[this.auth.language_cd + 'LOGIN17'], 'error');
      this.error_flag1 = true;
      // this.otp_flag = false;
      return;
    }

    this.otp_mobile_no = this.mobile_number;
    var resp = await this.auth.sendMsg(this.mobile_number);
    if (resp['Status'] == 'Success') {
      this.otp_flag = true;
      this.session_id = resp['Details']
      Swal.fire(this.auth.allLableShowObj[this.auth.language_cd + 'LOGIN16'], this.auth.allLableShowObj[this.auth.language_cd + 'LOGIN15'], 'success');
    }
  }



  async loginToAll() {
    this.tspinner.show('', '')
    if (/[A-Z]/.test(this.mobile_number) || /[a-z]/.test(this.mobile_number) || /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(this.mobile_number) || await !this.checkMobileNumber(this.mobile_number)) {
      this.tspinner.hide()
      Swal.fire('Error', 'Enter valid mobile number', 'error');
      return
    }
    this.otp_no = undefined
    let obj: any = {}
    obj['ident_to_verify'] = this.mobile_number;
    obj['ident_verify_method'] = 'OTP';
    this.otp_no = undefined
    let resp = await this.auth.loginToAll(obj);
    if (resp['error'] == false) {
      sessionStorage.setItem('1001', resp['data']['gateway_id']);
      sessionStorage.setItem('1000', resp['data']['token']);
      this.otp_mobile_no = this.mobile_number;
      this.resendOTP()
      this.tspinner.hide()
      Swal.fire('Success', resp['data']['data'], 'success')
      this.otp_flag = true;
      this.sendOTPbutonHide = true
      this.error_flag1 = true;
    } else {
      this.sendOTPbutonHide = false
      this.error_flag1 = false;
      this.tspinner.hide()
      Swal.fire('Opps !!', resp['data'], 'error')
    }

  }

  checkOTP(otp: Number) {
    return String(otp).length > 5
  }
  checkMobileNumber(mobile_number: Number) {
    return String(mobile_number).length == 10
  }

  async verifyLoginToAll() {
    this.tspinner.show('', '');
    if (this.mobile_number == undefined || this.otp_no == undefined || !this.otp_flag) {
      this.tspinner.hide()
      return
    }
    if (this.mobile_number == this.otp_mobile_no) {
      if (/[A-Z]/.test(this.otp_no) || /[a-z]/.test(this.otp_no) || /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(this.otp_no) || await !this.checkOTP(this.otp_no)) {
        this.tspinner.hide()
        Swal.fire('Error', 'OTP not matched', 'error');
        return
      }

      let obj: any = {}
      obj['otp_no'] = this.otp_no
      obj['ident_verify_method'] = "OTP"
      this.login_obj['login_id'] = this.mobile_number;
      // obj['gateway_id'] = sessionStorage.getItem("1002") as any
      let resp = await this.auth.verifyLoginToAll(obj);
      if (resp['error'] == false && resp['data'].length > 0) {
        this.AllAccountData = resp['data'];
        this.token = resp['token']['data'];

        if (resp['data'].length > 1) {
          await this.selectMultiAccount();
        } else {
          await this.selectOneAccount();
        }
      } else if (resp['error'] == true && resp['data'].length == 0) {
        this.login_obj['status'] = "FAIL";
        this.login_obj['user_id'] = null;
        this.login_obj['message'] =
          this.auth.allLableShowObj[this.auth.language_cd + 'LOGIN18'];
        this.tspinner.hide()
        Swal.fire("opps", resp['data'], 'error');
        await this.insertLoginInfo(this.login_obj);
      } else if (resp['error'] == true) {
        this.login_obj['status'] = "FAIL";
        this.login_obj['user_id'] = null;
        this.login_obj['message'] = resp['data'];
        this.tspinner.hide()
        Swal.fire('Error...', resp['data'], 'error')
        await this.insertLoginInfo(this.login_obj);
      }


    } else {
      this.tspinner.hide()
      Swal.fire('Error...', 'Mobile Number Not Match!', 'error')
    }
  }








  session_id: any
  async LoginWithOtp() {
    if (this.mobile_number == this.otp_mobile_no) {
      this.login_obj['login_type'] = 'OTP';
      this.login_obj['login_id'] = this.otp_mobile_no;
      this.login_obj['password'] = null;
      if (await this.auth.verifyMsg(this.otp_no, this.session_id)) {
        var obj: any = new Object();
        obj['ident_to_verify'] = this.mobile_number;
        obj['ident_verify_method'] = 'OTP';
        var resp = await this.auth.loginERP(obj);
        if (resp['error'] == false && resp['data'].length > 0) {

          this.AllAccountData = resp['data'];
          this.token = resp['token']['data'];
          for (let i = 0; i < this.AllAccountData.length; i++) {
            this.AllAccountData[i]['acct_desc'] = this.AllAccountData[i]['b_acct_id'] + " - " + this.AllAccountData[i]['account_name']
          }
          // this.spinner.hide();
          if (resp['data'].length > 1) {
            await this.selectMultiAccount();
          } else {
            await this.selectOneAccount();
          }

        } else if (resp['data'].length == 0) {
          this.tspinner.hide();
          this.login_obj['status'] = "FAIL";
          this.login_obj['user_id'] = null;
          this.login_obj['message'] = this.auth.allLableShowObj[this.auth.language_cd + 'LOGIN18'];

          await this.insertLoginInfo(this.login_obj);
          Swal.fire("opps", this.auth.allLableShowObj[this.auth.language_cd + 'LOGIN18'], 'error');
        } else if (resp['error'] == true) {
          this.tspinner.hide();
          this.login_obj['status'] = "FAIL";
          this.login_obj['user_id'] = null;
          this.login_obj['message'] = 'Login Failed due to api error true';

          await this.insertLoginInfo(this.login_obj);
          Swal.fire('Error...', 'Login Failed', 'error')
        }
      } else {
        this.tspinner.hide();
        this.login_obj['status'] = "FAIL";
        this.login_obj['user_id'] = null;
        this.login_obj['message'] = 'OTP Not Match!';

        await this.insertLoginInfo(this.login_obj);

        Swal.fire('Error...', 'OTP Not Match!', 'error')
      }
    } else {
      this.tspinner.hide();
      Swal.fire('Error...', 'Mobile Number Not Match!', 'error')
    }



  }


  //social media login
  // public socialSignIn(socialProvider: string) {

  //   let socialPlatformProvider:any;
  //   if (socialProvider === 'facebook') {
  //     socialPlatformProvider = FacebookLoginProvider.PROVIDER_ID;
  //   } else if (socialProvider === 'google') {
  //     socialPlatformProvider = GoogleLoginProvider.PROVIDER_ID;
  //   }

  //   this.OAuth.signIn(socialPlatformProvider).then(async socialusers => {


  //     var obj:any = new Object();
  //     obj['ident_to_verify'] = socialusers['email'];
  //     obj['ident_verify_method'] = 'GOA';

  //     this.login_obj['login_id'] = socialusers['email'];
  //     this.login_obj['password'] = null;
  //     this.login_obj['login_type'] = 'GOA';

  //     this.spinner.show();;
  //     var resp = await this.auth.loginERP(obj);
  //     if (resp['error'] == false && resp['data'].length > 0) {
  //       this.AllAccountData = resp['data'];
  //       this.token = resp['token']['data'];
  //       for (let i = 0; i < this.AllAccountData.length; i++) {
  //         this.AllAccountData[i]['acct_desc'] = this.AllAccountData[i]['b_acct_id'] + " - " + this.AllAccountData[i]['account_name']
  //       }
  //       this.spinner.hide();

  //       if (resp['data'].length > 1) {
  //         await this.selectMultiAccount();
  //       } else {
  //         await this.selectOneAccount();
  //       }

  //     } else if (resp['data'].length == 0) {
  //       this.spinner.hide();
  //       this.login_obj['status'] = "FAIL";
  //       this.login_obj['user_id'] = null;
  //       this.login_obj['message'] = this.auth.allLableShowObj[this.auth.language_cd + 'LOGIN18'];
  //       await this.insertLoginInfo(this.login_obj);
  //       Swal.fire("opps", this.auth.allLableShowObj[this.auth.language_cd + 'LOGIN18'], 'error');
  //     }
  //     else {
  //       this.spinner.hide();
  //       this.login_obj['status'] = "FAIL";
  //       this.login_obj['user_id'] = null;
  //       this.login_obj['message'] = 'Login Failed';

  //       await this.insertLoginInfo(this.login_obj);
  //       Swal.fire("opps", "Login Failed", 'error');
  //     }
  //   });
  // };
  assigned_accounts: any = []
  token: any;
  login: any = {}
  async logins() {
    this.tspinner.show('', '')
    if (this.currentlyChecked == 0 || this.currentlyChecked == 1) {
      var valid_mob = this.validatePhoneNumber(this.obj['email'])
      var valid_email = this.validateEmail(this.obj['email']);

      this.login_obj['login_type'] = 'PASSWORD';
      this.login_obj['login_id'] = this.obj['email'];
      this.login_obj['password'] = null;

      if (valid_mob == true && this.currentlyChecked == 0) {
        var obj: any = new Object();
        obj['ident_to_verify'] = this.obj['email'];
        obj['ident_verify_method'] = 'P-KEY';
        obj['ident_verify_secret'] = this.obj['password'];
        // this.spinner.show();
        var resp = await this.auth.loginERP(obj);
        if (resp['error'] == false && resp['data'].length > 0) {
          this.AllAccountData = resp['data'];
          this.token = resp['token'];
          for (let i = 0; i < this.AllAccountData.length; i++) {
            this.AllAccountData[i]['acct_desc'] = this.AllAccountData[i]['b_acct_id'] + " - " + this.AllAccountData[i]['account_name']
            this.assigned_accounts.push(this.AllAccountData[i]['account_short_name'])
          }
          sessionStorage.setItem('1001', resp['gateway_id']);
          sessionStorage.setItem('1000', resp['token']);

          if (resp['data'].length > 1) {
            await this.selectMultiAccount();
          } else {
            await this.selectOneAccount();
          }

          this.tspinner.hide()
        } else if (resp['data'].length == 0) {
          this.tspinner.hide();
          this.login_obj['status'] = "FAIL";
          this.login_obj['user_id'] = null;
          this.login_obj['message'] = this.auth.allLableShowObj[this.auth.language_cd + 'LOGIN18'];

          await this.insertLoginInfo(this.login_obj);
          Swal.fire("opps", this.auth.allLableShowObj[this.auth.language_cd + 'LOGIN18'], 'error');
        } else {
          this.tspinner.hide();
          this.login_obj['status'] = "FAIL";
          this.login_obj['user_id'] = null;
          this.login_obj['message'] = 'This Email Or Mobile Is Not Registered';

          await this.insertLoginInfo(this.login_obj);
          Swal.fire('Error...', 'This Email Or Mobile Is Not Registered', 'error')
        }
      } else if (valid_email == true && this.currentlyChecked == 1) {
        this.tspinner.show('', '');
        var obj: any = new Object();
        obj['ident_to_verify'] = this.obj['email'];
        obj['ident_verify_method'] = 'E-KEY';
        obj['ident_verify_secret'] = this.obj['password'];

        var resp = await this.auth.loginERP(obj);
        if (resp['error'] == false && resp['data'].length > 0) {

          this.AllAccountData = resp['data'];
          for (let i = 0; i < this.AllAccountData.length; i++) {
            this.AllAccountData[i]['acct_desc'] = this.AllAccountData[i]['b_acct_id'] + " - " + this.AllAccountData[i]['account_name']
          }

          if (resp['data'].length > 1) {
            await this.selectMultiAccount();
          } else {
            await this.selectOneAccount();
          }

          this.tspinner.hide();
        } else if (resp['data'].length == 0) {
          this.tspinner.hide();
          this.login_obj['status'] = "FAIL";
          this.login_obj['user_id'] = null;
          this.login_obj['message'] = this.auth.allLableShowObj[this.auth.language_cd + 'LOGIN18']

          await this.insertLoginInfo(this.login_obj);
          Swal.fire("opps", this.auth.allLableShowObj[this.auth.language_cd + 'LOGIN18'], 'error');
        } else {
          this.tspinner.hide();
          this.login_obj['status'] = "FAIL";
          this.login_obj['user_id'] = null;
          this.login_obj['message'] = this.auth.allLableShowObj[this.auth.language_cd + 'LOGIN18']

          await this.insertLoginInfo(this.login_obj);
          Swal.fire('Error...', this.auth.allLableShowObj[this.auth.language_cd + 'LOGIN18'], 'error')
        }
      }
      else {
        this.tspinner.hide()
        Swal.fire('Error...', this.auth.allLableShowObj[this.auth.language_cd + 'LOGIN20'], 'error')
      }

    } else {
      this.tspinner.hide()
      Swal.fire('Warning', ' Please Select An Option For Login', 'warning')
    }
  }


  check_box_type = CheckBoxType;
  currentlyChecked: CheckBoxType = 0;
  selectCheckBox(targetType: CheckBoxType) {
    // If the checkbox was already checked, clear the currentlyChecked variable
    if (this.currentlyChecked === targetType) {
      this.currentlyChecked = CheckBoxType.NONE;
      return;
    }

    this.currentlyChecked = targetType;

  }


  validatePhoneNumber(input_str: any) {
    var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    return re.test(input_str);
  }
  validateEmail(input_str: any) {
    var re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/im;
    return re.test(input_str);
  }

  change(vale: boolean) {
    this.login_with_password = vale;
  }

  login_with_otp = true;
  login_with_password = false;
  login_with_google_oath = true;

  async selectOneAccount() {
    this.b_account_id = this.AllAccountData[0]['b_acct_id'];
    await this.submitAccount();
  }

  async selectMultiAccount() {
    $('#multi_account').modal('show');
  }

  b_account_id: any;
  async submitAccount() {
    $('#multi_account').modal('hide');

    if (this.b_account_id == undefined || this.b_account_id == null) {
      this.tspinner.hide()
      Swal.fire('Error...', 'Login Failed!', 'error')
      return;
    }

    for (let i = 0; i < this.AllAccountData.length; i++) {
      if (this.AllAccountData[i]['b_acct_id'] == this.b_account_id) {
        this.login = this.AllAccountData[i];
      }
    }
    let user_id = ''
    const characters = '58974259988174808546';
    for (let i = 0; i < 19; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      user_id += characters[randomIndex];
    }
    sessionStorage.setItem('1005', `${user_id.substring(0, 9)}${this.login['b_acct_id']}${user_id.substring(10, 19)}`);
    this.login['assigned_product_cd'] = await this.getAccountModule(this.login['b_acct_id']);
    this.login['user_id'] = this.login['le_id'];
    await this.getUserRoleInfo(this.login);
  }

  allowLoginValidate() {
    if (String(this.mobile_number).length > 10) {
      this.mobile_number = Number(String(this.mobile_number).slice(0, 10));
    }
    this.allowLogin = false
    this.otp_flag = false
    this.otp_no = undefined
    this.sendOTPbutonHide = false


  }

  forgetPassWord() {
    $('#forget').modal('show');
  }




  AllUserRole = [];
  assigned_User_Roles: any = [];
  assigned_user_modules: any = [];



  //get Account Related Module
  async getAccountModule(b_acct_id: any) {
    var obj: any = new Object();
    obj['b_acct_id'] = b_acct_id;
    var resp: any = await this.auth.getaccountmodule(JSON.stringify(obj));
    if (resp['error'] == false) {
      return resp['data'][0]['module_cd'].split(",");
    } else {
      this.tspinner.hide()
      this.snackBar.open(resp['data'], 'Error', {
        duration: 5000,
      });
    }
    return []
  }


  //Get User Related Role Data From data_auth
  async getUserRoleInfo(acct_info: any) {
    this.assigned_User_Roles = []
    var obj1: any = new Object();
    obj1['user_id'] = acct_info.user_id;
    obj1['b_acct_id'] = acct_info.b_acct_id;
    var resp;
    if (acct_info.b_acct_id == 0) {
      resp = await this.auth.getCurrentUserFromAdmin(JSON.stringify(obj1));
    } else {
      resp = await this.auth.getCurrentUserFromMD(JSON.stringify(obj1));
    }
    if (resp['error'] == false) {
      this.AllUserRole = resp.data;
      for (let i = 0; i < this.AllUserRole.length; i++) {
        this.assigned_User_Roles.push(this.AllUserRole[i]['role_cd']);
      }
      await this.finalSubmit();
    } else {
      this.tspinner.hide()
    }
  }


  //get User Resource And User Module Data
  async getAllAssignedComponent(b_acct_id: any, role_cd: any) {
    // this.spinner.show()
    var obj: any = new Object();
    obj['b_acct_id'] = b_acct_id;
    obj['role_cd'] = role_cd;
    var resp
    if (b_acct_id == 0) {
      resp = await this.mainServiceADMIN.getresourcebyrolecd(JSON.stringify(obj));
    } else {
      resp = await this.mainService.getAllAssignedComponents(JSON.stringify(obj));
    }
    var allComponentCode: any = [];
    this.assigned_user_modules = [];
    if (resp['error'] == false) {
      // this.spinner.hide()
      for (let i = 0; i < resp['data'].length; i++) {
        if (!this.assigned_user_modules.includes(resp['data'][i]['module_cd'])) {
          this.assigned_user_modules.push(resp['data'][i]['module_cd'])
        }
        allComponentCode.push(resp['data'][i]['resource_cd'])
      }
      this.login['module_cd'] = this.assigned_user_modules;
      return allComponentCode;
    } else {
      this.tspinner.hide();
      Swal.fire('Error', 'Error While Getting All Resource', 'error')
      return allComponentCode;
    }
  }


  //Final Submit Function Of Sign In
  async finalSubmit() {
    this.login['role_cd'] = this.assigned_User_Roles;
    // this.login['assigned_component'] = await this.getAllAssignedComponent(this.login['b_acct_id'], this.assigned_User_Roles);
    this.login['party_name'] = await this.getSetPartyName(this.login['b_acct_id'], this.login['contact_email'], this.login['phone_no'])
    let obj: any = {}
    obj['erpUser'] = JSON.stringify(this.login)
    let resp = await this.auth.updateSession(obj)
    if (resp['error'] == false) {
      $('#multi_role').modal('hide');
      session.erpUser = {}
      // session.erpUser = btoa(JSON.stringify(this.login))
      session.erpUser = this.utf8EncodingService.encodeToUtf8((JSON.stringify(this.login)))
      sessionStorage.setItem('1000', this.token);
      this.login_obj['status'] = "PASS";
      this.login_obj['user_id'] = "User ID:" + this.login['le_id'] + " & In Account Id:" + this.login['b_acct_id'];
      // let user_id = ''
      // const characters = '58974259988174808546';
      // for (let i = 0; i < 19; i++) {
      //     const randomIndex = Math.floor(Math.random() * characters.length);
      //     user_id += characters[randomIndex];
      // }
      // sessionStorage.setItem('1005', `${user_id.substring(0, 9)}${this.login['b_acct_id']}${user_id.substring(10, 19)}`);
      // en['1005']=`${user_id.substring(0, 9)}${this.login['b_acct_id']}${user_id.substring(10, 19)}`
      this.login_obj['message'] = this.auth.allLableShowObj[this.auth.language_cd + 'LOGIN19']
      this.tspinner.hide()
      Swal.fire('Success...', this.auth.allLableShowObj[this.auth.language_cd + 'LOGIN19'], 'success');
      if (this.login['b_acct_id'] == 0) {
        this.router.navigate(["/solution-admin/index"])
      } else {
        if (this.login['role_cd'].includes('DIRECTOR') || this.login['role_cd'].includes('Dir')) {
          this.router.navigate(['./file-overView']); //route to director-dashboard
        } else {
          this.router.navigate(['/index']);
        }
        await this.insertLoginInfo(this.login_obj);

      }
    } else {
      this.tspinner.hide()
      Swal.fire('Opps!!', resp['data'], 'error')
    }

  }


  async getSetPartyName(b_acct_id: any, email: any, phone_no: any) {
    let obj: any = {}
    obj['b_acct_id'] = b_acct_id
    obj['contact_email'] = email
    obj['phone_no'] = phone_no
    var resp = await this.mainServiceADMIN.getCurrentLegalEntity(JSON.stringify(obj));
    if (resp['error'] == false) {
      return resp['data'][0]['party_name'];
    } else {
      return 'NA'
    }
  }

  submitRoleAndZone() {

  }

}
